import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const RepresentativeField = ({ record = {} }) => {
  if (!record) {
    return null;
  }
  const {
    email,
    role,
  } = record;
  const fullName = `${email}`;
  return (
    <span
      style={{
        fontSize: '0.875rem',
        fontWeight: 400,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        lineHeight: '1.46429em',
      }}
    >
      {fullName} {role && `(${role})`}
    </span>
  );
};

RepresentativeField.defaultProps = {
  label: 'Full Name',
  addLabel: true,
};



// WEBPACK FOOTER //
// ./src/components/SolicitedUsers/Fields.js